const throttle = <T extends (...args: any[]) => any>(func: T, wait: number): ((...args: Parameters<T>) => void) => {
  let timeout: NodeJS.Timeout | null = null;
  let lastRan: number | null = null;

  return function throttled(this: any, ...args: Parameters<T>) {
    if (!lastRan) {
      func.apply(this, args);
      lastRan = Date.now();
    } else {
      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(
        () => {
          if (Date.now() - (lastRan as number) >= wait) {
            func.apply(this, args);
            lastRan = Date.now();
          }
        },
        wait - (Date.now() - lastRan)
      );
    }
  };
};

export default throttle;
